// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2G4Ew","title":"Info_title__ZOCuH","links":"Info_links__3Zw5I","link":"Info_link__1Hgv5","logo":"Info_logo__2cGi2"};